module.exports = __webpack_public_path__ + "public/img/640.fc72e35c.gif";